import type { ReactNode } from 'react';

import classNames from 'classnames';

import ImageProxy from '@next-image-proxy';

import iconBackground from '@shared/assets/images/icon-background.png';

export interface CustomStoryStatCardProps {
  title: ReactNode;
  description?: ReactNode;
  stat: ReactNode;
  icon: ReactNode;
  className?: string;
}

const CustomStoryStatCard = ({
  title,
  description,
  stat,
  icon,
  className,
}: CustomStoryStatCardProps) => {
  const showDescription = !!description;

  return (
    <div className={classNames('flex flex-col gap-2.5 md:gap-4', className)}>
      <div className="relative self-start inline-flex justify-center items-center">
        <ImageProxy alt="" src={iconBackground} className="w-12 h-12" />

        <div className="text-secondary-700 icon absolute">{icon}</div>
      </div>

      <span className="text-lg md:text-2xl font-semibold text-secondary-700">{title}</span>

      <span className="text-xl md:text-3xl font-medium">{stat}</span>

      {showDescription && (
        <span className="text-sm font-medium text-neutral-500 flex-1">{description}</span>
      )}

      <div className="w-full h-0.5 mt-auto rounded-sm bg-gradient-to-r from-[#FF6647] via-[#E14BFF] to-[#4AA5FF]" />
    </div>
  );
};

export default CustomStoryStatCard;
